import Logo from '../assets/logo.png';
import GithubLogo from '../assets/github.png';

export const LINKS_FOOTER = [
  {
    name: 'Vlad Stepanov',
    link: 'https://github.com/wlladislaw/',
    img: `${GithubLogo}`,
  },
  {
    name: 'Mikhail Matveichuk',
    link: 'https://github.com/MihailMatveichuk/',
    img: `${GithubLogo}`,
  },
  {
    name: 'RSS School',
    link: 'https://rs.school/js/',
    img: `${Logo}`,
  },
];
